import { View, LegacyBox, styled } from '@gogame/components';
import { Link } from '@gogame/screens';

export const WizardViewStyled = styled(View)`
  min-height: calc(100vh - 64px - 16px);
`;
//
// export const WizardBodyStyled = styled(Screen.Body)`
//   flex-direction: row;
//   height: 100%;
//   align-items: flex-start;
//   min-height: 700px;
// `;

export const TableWrapperStyled = styled(LegacyBox)`
  width: 100%;
  overflow-x: auto;
  flex: 0 0 auto;
  z-index: 1;
`;

export const NameCellBox = styled(LegacyBox)`
  min-width: 165px;
`;

export const NameLinkStyled = styled(Link)`
  display: block;
  text-decoration: none;
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const stylesSticky = {
  position: 'sticky',
  zIndex: 2,
};
